import React from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "../../../Common/Tooltip";

const SearchInput = ({
  search,
  setSearch,
  pagination,
  setPagination,
  setIsLoading,
}) => {
  const { t: translator } = useTranslation();
  return (
    <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
      <label>{translator("Documents-Filters-SearchText")}</label>{" "}
      <Tooltip text={translator("InitialStateTooltip-Msg")} />
      <input
        type="text"
        className="form-control"
        value={search.searchText}
        onChange={(event) => {
          setIsLoading(true);
          setSearch({
            ...search,
            searchText: event.target.value,
          });
          setPagination({ ...pagination, pageIndex: 0 });
        }}
      />
    </div>
  );
};

export default SearchInput;
